const helpConfiguration = {
  on_login_screen:
    'Enlace de ayuda para mostrar en la pantalla de inicio de sesión',
  on_dashboard: 'Enlace de ayuda para mostrar en el tablero',
  test_link: 'Probar enlance',
  invalid_format: 'Formato de URL inválido',
};

export default helpConfiguration;
